<ion-app>
  <ion-router-outlet id="ionRouterOutletId" [swipeGesture]="false"></ion-router-outlet>
  <app-offline *ngIf="isOffline"></app-offline>
</ion-app>
